import React, { useEffect, useRef, useState } from "react";
import * as Icon from "react-bootstrap-icons";
import { motion } from "framer-motion";
import { useSelector } from "react-redux";
import { getContent } from "../../../utils/main";
import ReCAPTCHA from "react-google-recaptcha";
import { Link } from "react-router-dom";
import axios from "axios";
import { Spinner } from "react-bootstrap";

const Subscribe = () => {
  const content = useSelector((state) => state.mainSlice.content);
  const lang = useSelector((state) => state.mainSlice.lang);
  const [email, setEmail] = useState("");
  const [read, setRead] = useState(false);
  const [captcha, setCaptcha] = useState(null);
  const [formMessage, setFormMessage] = useState("");
  const [messageStatus, setMessageStatus] = useState("text-success");
  const [loading, setLoading] = useState(false);
  const [showClear, setShowClear] = useState(false);
  const variants = {
    visible: { opacity: 1, x: 0 },
    hidden: { opacity: 0, x: -150 },
  };

  useEffect(() => {
    setCaptcha(null);
  }, []);

  const emailRef = useRef(null);
  const checkRef = useRef(null);

  function isValidEmail(email) {
    return /\S+@\S+\.\S+/.test(email);
  }

  const _handleSubmit = (event) => {
    event.preventDefault();
    const formData = new FormData();
    var _error = "";
    if (email === "" || !isValidEmail(email)) {
      _error = "Enter valid email address!";
    } else {
      formData.append("email", email);
    }
    if (!read) {
      _error = "Read rules and check the box!";
    }
    if (captcha === null || captcha === "") {
      _error = "Captcha is required!";
    } else {
      formData.append("captcha", captcha);
    }
    if (_error === "") {
      setLoading(true);
      axios({
        method: "post",
        url: `${process.env.REACT_APP_API_URL}/api/v1/subscribe/create/`,
        data: formData,
        headers: { "Content-Type": "multipart/form-data" },
      })
        .then((data) => {
          if (data.status === 200) {
            localStorage.setItem("email", email);
            setFormMessage(
              getContent(
                content,
                "We sent activation link to your email address",
                lang
              )
            );
            setMessageStatus("text-success");
          } else {
            setFormMessage(data.response.data.detail[lang]);
            setMessageStatus("text-danger");
          }
        })
        .catch((data) => {
          setFormMessage(data.response.data.detail[lang]);
          setMessageStatus("text-danger");
        })
        .finally(() => {
          setLoading(false);
          setShowClear(true);
        });
    } else {
      setFormMessage(_error);
      setMessageStatus("text-danger");
    }
  };

  const _handleClear = () => {
    setFormMessage("");
    emailRef.current.value = "";
    checkRef.current.checked = false;
    setRead(false);
    setEmail("");
    setShowClear(false);
  };

  return (
    <motion.div
      variants={variants}
      transition={{ duration: 0.8 }}
      initial="hidden"
      animate="visible"
      className="outer-left"
    >
      <div className="left">
        <h4 className="mb-0">
          {getContent(content, "Subscribe to us", lang)} <Icon.ArrowRight />
        </h4>
        <p className="mb-0">
          {getContent(
            content,
            "First of the news\nSubscribe to us to stay informed.",
            lang
          )}
        </p>
      </div>
      <div className="right">
        <form action="" onSubmit={_handleSubmit}>
          {loading === true ? (
            <Spinner
              style={{ width: "10px", height: "10px", borderWidth: "2px" }}
            />
          ) : formMessage !== "" ? (
            <span className={`subscribe-error ${messageStatus}`}>
              {formMessage}
            </span>
          ) : (
            ""
          )}
          <div className="form-group">
            <div className="inputs-wrapper">
              <input
                type="email"
                name="email"
                onChange={(event) => {
                  setEmail(event.target.value);
                }}
                ref={emailRef}
                required
                placeholder={getContent(content, "Enter your E-mail", lang)}
              />
              <input
                type="submit"
                value={getContent(content, "Subscribe", lang)}
                className="subscribe clear-btn"
              />
            </div>
          </div>
          <div className="form-group d-flex position-relative">
            <input
              type="checkbox"
              name="privacy"
              ref={checkRef}
              onChange={() => {
                setRead(!read);
              }}
              id="privacy"
              required
            />
            {lang === "en" ? (
              <label htmlFor="privacy">
                I read and agree with{" "}
                <Link to="/pages/ylalashyk">the rules</Link>
              </label>
            ) : lang === "ru" ? (
              <label htmlFor="privacy">
                <Link to="/pages/ylalashyk">С правилами</Link> ознакомлен
              </label>
            ) : (
              <label htmlFor="privacy">
                <Link to="/pages/ylalashyk">Düzgünler</Link> bilen tanyşdym
              </label>
            )}
            {showClear === true ? (
              <span className="subscribe-clear" onClick={() => _handleClear()}>
                &times;
              </span>
            ) : (
              ""
            )}
            {read ? (
              <div className="captcha-wrapper position-absolute top-100 mt-2">
                <ReCAPTCHA
                  sitekey="6Lc5naImAAAAAFd5yWkdd56mSJpiAghI1wyTTgCh"
                  onChange={(value) => setCaptcha(value)}
                />
              </div>
            ) : (
              ""
            )}
          </div>
        </form>
      </div>
    </motion.div>
  );
};

export default Subscribe;
